// Rows cut into runs of one local calendar day: the session-history rail
// (`focus/FocusSessionRail.tsx`) and the meetings list
// (`focus/meetings/MeetingsPage.tsx`).
//
// Local, because the reader is. The input order is kept: a caller that wants
// newest first hands the rows in newest first. Group by the timestamp the
// list is sorted by: a day that appears twice in the input gets two groups
// (with the same key) rather than a reshuffle.

/** Local calendar day, as a sortable key (`YYYY-MM-DD`). */
export const dayKeyOf = (iso: string): string => {
  const d = new Date(iso);
  const m = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
};

export interface DayGroup<T> {
  readonly key: string;
  readonly entries: T[];
}

/** Rows in the order given, cut into runs of one local day each. */
export const groupByDay = <T>(
  entries: readonly T[],
  isoOf: (entry: T) => string,
): DayGroup<T>[] => {
  const groups: DayGroup<T>[] = [];
  for (const entry of entries) {
    const key = dayKeyOf(isoOf(entry));
    const last = groups[groups.length - 1];
    if (last !== undefined && last.key === key) last.entries.push(entry);
    else groups.push({ key, entries: [entry] });
  }
  return groups;
};
